<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-file-document"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Orders") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'order.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      /> -->
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1 mt-1"
        :filterCols="filterCols"
        :filters="filters"
        item-key="id"
        v-on:filter="
          filters = $event;
          getData();
        "
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.state.name="{ item }">
          {{ $t(item.state.name) }}
        </template>
        <template v-slot:item.project="{ item }">
          {{ item.project }} <sup>{{ item.country_code }}</sup>
          <v-icon
            v-for="(color, index) in item.icons"
            small
            :color="color"
            :key="index"
          >
            mdi-door</v-icon
          >
          <v-icon v-if="item.downloaded">mdi-download</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:item.confirmed_at="{ item }">
          {{
            item.confirmed_at
              ? moment(item.confirmed_at).format("DD.MM.YYYY")
              : "-"
          }}
        </template></advanced-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";
import axios from "axios";
import { persistentTableOptions } from "../../../plugins/mixins";

var cancel;
var CancelToken = axios.CancelToken;

export default {
  name: "app-order-list",
  mixins: [persistentTableOptions],
  data() {
    return {
      loading: true,
      options: {
        itemsPerPage: 50
      },
      total: 0,
      search: "",
      items: [],
      filters: []
    };
  },

  mounted() {
    this.getData();
  },

  computed: {
    headers() {
      if (this.$auth.check("order.editall")) {
        return [
          {
            text: this.$t("Company"),
            value: "company.name",
            sortable: false
          },
          {
            text: this.$t("Customer"),
            value: "customer.name"
          },
          {
            text: this.$t("order_number"),
            align: "left",
            value: "number"
          },
          {
            text: this.$t("order_date"),
            align: "left",
            value: "confirmed_at"
          },
          {
            text: this.$t("Project"),
            value: "project"
          },
          {
            text: this.$t("State"),
            value: "state.name"
          },
          { text: "", value: "action", sortable: false }
        ];
      } else {
        return [
          {
            text: this.$t("Number"),
            align: "left",
            value: "number"
          },
          {
            text: this.$t("Customer"),
            value: "customer.name"
          },

          {
            text: this.$t("Project"),
            value: "project"
          },
          {
            text: this.$t("State"),
            value: "state.name"
          },
          {
            text: this.$t("order_date"),
            align: "left",
            value: "confirmed_at"
          },
          { text: "", value: "action", sortable: false }
        ];
      }
    },
    filterCols() {
      if (this.$auth.check("order.editall")) {
        return [
          {
            title: this.$t("Company"),
            name: "customer.company.name",
            type: "text"
          },
          {
            title: this.$t("customer"),
            name: "customer.name",
            type: "text"
          },
          {
            title: this.$t("order_number"),
            name: "number",
            type: "text"
          },
          {
            title: this.$t("project"),
            name: "project",
            type: "text"
          },
          {
            title: this.$t("order_year"),
            name: "confirmed_at",
            type: "select",
            props: {
              itemText: "name",
              itemValue: "id"
            },
            items: [
              {
                id: 2021,
                name: "2021"
              },
              {
                id: 2022,
                name: "2022"
              },
              {
                id: 2023,
                name: "2023"
              },
              {
                id: 2024,
                name: "2024"
              },
              {
                id: 2025,
                name: "2025"
              },
              {
                id: 2026,
                name: "2026"
              }
            ]
          },
          {
            title: this.$t("state"),
            name: "state_id",
            type: "select",
            props: {
              itemText: "name",
              itemValue: "id"
            },
            items: [
              {
                id: 1,
                name: this.$t("draft")
              },
              {
                id: 2,
                name: this.$t("submitted")
              },
              {
                id: 3,
                name: this.$t("confirmed")
              },
              {
                id: 4,
                name: this.$t("payment_created")
              },
              {
                id: 5,
                name: this.$t("send")
              }
            ]
          },
          {
            title: this.$t("certificates_downloaded"),
            name: "downloaded",
            type: "select",
            props: {
              itemText: "name",
              itemValue: "id"
            },
            items: [
              {
                id: 0,
                name: this.$t("no")
              },
              {
                id: 1,
                name: this.$t("yes")
              }
            ]
          },
          {
            title: this.$t("country"),
            name: "country_id",
            type: "select",
            props: {
              itemText: "name",
              itemValue: "id"
            },
            items: [
              {
                id: 1,
                name: "IT"
              },
              {
                id: 2,
                name: "AUT"
              },
              {
                id: 3,
                name: "CH"
              },
              {
                id: 5,
                name: "DE"
              }
            ]
          }
        ];
      } else {
        return [
          {
            title: this.$t("order_number"),
            name: "number",
            type: "text"
          },
          {
            title: this.$t("customer"),
            name: "customer.name",
            type: "text"
          },
          {
            title: this.$t("project"),
            name: "project",
            type: "text"
          },
          {
            title: this.$t("state"),
            name: "state_id",
            type: "select",
            props: {
              itemText: "name",
              itemValue: "id"
            },
            items: [
              {
                id: 1,
                name: this.$t("draft")
              },
              {
                id: 2,
                name: this.$t("submitted")
              },
              {
                id: 3,
                name: this.$t("confirmed")
              },
              {
                id: 4,
                name: this.$t("payment_created")
              },
              {
                id: 5,
                name: this.$t("send")
              }
            ]
          },
          {
            title: this.$t("certificates_downloaded"),
            name: "downloaded",
            type: "select",
            props: {
              itemText: "name",
              itemValue: "id"
            },
            items: [
              {
                id: 0,
                name: this.$t("no")
              },
              {
                id: 1,
                name: this.$t("yes")
              }
            ]
          },
          {
            title: this.$t("country"),
            name: "country_id",
            type: "select",
            props: {
              itemText: "name",
              itemValue: "id"
            },
            items: [
              {
                id: 1,
                name: "IT"
              },
              {
                id: 2,
                name: "AUT"
              },
              {
                id: 3,
                name: "CH"
              },
              {
                id: 5,
                name: "DE"
              }
            ]
          }
        ];
      }
    }
  },

  methods: {
    async getData() {
      this.loading = true;
      if (cancel != undefined) {
        cancel();
      }
      let response = await fetchItems(
        {
          ...this.options,
          search: this.search,
          filters: this.filters
        },
        new CancelToken(function executor(c) {
          cancel = c;
        })
      );

      this.items = response.data;
      this.total = response.meta.total;
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Order?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "order.edit", params: { id: url } });
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
